export default {"src":"/_next/static/media/user-plus-solid.10194ea1.svg","height":512,"width":640};